import { render, staticRenderFns } from "./number-filter.vue?vue&type=template&id=5894c06b&scoped=true&"
import script from "./number-filter.vue?vue&type=script&lang=js&"
export * from "./number-filter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5894c06b",
  null
  
)

export default component.exports